import script from "./ProjectImageGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectImageGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectImageGallery.vue?vue&type=style&index=0&id=a9089e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9089e1a"]])

export default __exports__